import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from '../../utils/platform';
import styles from './BetaBanner.module.css';

const STORAGE_KEY = 'beta_banner_dismissed';

interface BetaBannerProps {
  dismissible?: boolean;
  onView?: () => void;
  onDismiss?: () => void;
}

export default function BetaBanner({ dismissible = false, onView, onDismiss }: BetaBannerProps) {
  const { t } = useTranslation('common');
  // Suppressed on mobile, where AppInstallBanner is the single banner.
  const [isMobile] = useState(() => isMobileDevice());
  const [dismissed, setDismissed] = useState(() =>
    dismissible ? localStorage.getItem(STORAGE_KEY) === 'true' : false
  );

  useEffect(() => {
    if (dismissible && !dismissed && !isMobile) {
      onView?.();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isMobile || dismissed) return null;

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
    onDismiss?.();
  }

  return (
    <div className={styles.banner} role="region" aria-label={t('betaBanner.ariaLabel')}>
      <div className={styles.inner}>
        <p className={styles.text}>
          {dismissible ? t('betaBanner.inApp') : t('betaBanner.landing')}
        </p>
        {dismissible && (
          <button
            type="button"
            className={styles.dismissButton}
            onClick={handleDismiss}
            aria-label={t('dismiss')}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
